import * as React from 'react';
import { Renderer, Resource } from '../../../webana';
import { observer } from 'mobx-react';
import { Subscriber, Broadcast } from 'react-broadcast';
import * as moment from 'moment';

@observer
export class ContractCopyComponent extends React.Component<any> {
  state = {
    error: ""
  };

  async componentDidMount() {
    const { router, redirect } = this.props.context;
    const vars = router.location.state;
    const dFormat = "YYYY-MM-DDTHH:mm:ssZ";

    let data = {
      name: "zakazka",
      id: vars.commission,
      fields: "ID newID",
      args: {
        dZakPlanFr: moment(vars.start).format(dFormat),
        dZakPlanTo: moment(vars.end).format(dFormat),
      },
    };

    const showError = () => {
      alert("Chyba při kopii zakázky!");
      redirect(".", { zakKopieC: false });
    }

    try {
      const result = await this.sendResource(data);
      const id = result.newID;
      
      if (!id) {
        showError();
        return;
      }

      let lState = {
        zakKopieC: false, 
        showCalendarZak: false,
        redirectToCalendar: true,
        comDetailHide: true
      };

      router.location.state = { ...vars, ...lState};
      redirect("/commissions/" + id, router.location.state);
      
      // obnoveni komponenty commission detail
      redirect(".", { comDetailHide: false });
    }
    catch (e) {
      console.log("Chyba při kopii zakázky: ", e);
      showError();
      this.props.resources.plans.reload();
    }
  }

  sendResource = async (resource: any) => {
    resource.dataSource = "api";
    const res = new Resource(resource as any);
    return await res.raw(resource.args);
  }

  render() {
    const { config, context } = this.props;

    return (
      <div style={config.style} className={config.className}>
        <div className="error-red">{this.state.error}</div>
        <Broadcast channel="context" value={context}>
          <Renderer content={config.content} />
        </Broadcast>
      </div>
    );
  }
}

export class ContractCopy extends React.Component<any> {
  render() {
    return (
      <Subscriber channel="context">
        {ctx => {
          return <ContractCopyComponent {...this.props} context={ctx} /> 
        } }
      </Subscriber>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/sezako/components/ContractCopy.tsx